<div class="page-not-found">
    <img src="/assets/images/unauthorized_img.svg" />
    <h1>
        Unauthorized
    </h1>
    <p>You are not authorized to access this page.</p>
    <button id="unauthorized_Login" type="button" class="btn btn-blue" (click)="loginUser()">Login</button>
</div>